/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as AppRouteImport } from './../../pages/_app'
import { Route as PublicRouteImport } from './../../pages/_public'
import { Route as AppIndexRouteImport } from './../../pages/_app/index'
import { Route as PublicLoginRouteImport } from './../../pages/_public/login'
import { Route as AppCompaniesIndexRouteImport } from './../../pages/_app/companies/index'
import { Route as AppCompaniesCompanyIdRouteImport } from './../../pages/_app/companies/$companyId'
import { Route as AppEmployeesIndexRouteImport } from './../../pages/_app/employees/index'
import { Route as AppEmployeesEmployeeIdRouteImport } from './../../pages/_app/employees/$employeeId'
import { Route as AppProjectsIndexRouteImport } from './../../pages/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './../../pages/_app/projects/$projectId'
import { Route as PublicCustomerIndexRouteImport } from './../../pages/_public/customer/index'
import { Route as PublicCustomerLoginRouteImport } from './../../pages/_public/customer/login'
import { Route as PublicCustomerLogoutRouteImport } from './../../pages/_public/customer/logout'
import { Route as PublicCustomerPasswordRouteImport } from './../../pages/_public/customer/password'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AppCompaniesIndexRoute = AppCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesCompanyIdRoute = AppCompaniesCompanyIdRouteImport.update({
  id: '/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesIndexRoute = AppEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesEmployeeIdRoute = AppEmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const PublicCustomerIndexRoute = PublicCustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCustomerLoginRoute = PublicCustomerLoginRouteImport.update({
  id: '/customer/login',
  path: '/customer/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCustomerLogoutRoute = PublicCustomerLogoutRouteImport.update({
  id: '/customer/logout',
  path: '/customer/logout',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCustomerPasswordRoute = PublicCustomerPasswordRouteImport.update({
  id: '/customer/password',
  path: '/customer/password',
  getParentRoute: () => PublicRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof PublicLoginRoute
  '/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/customer/login': typeof PublicCustomerLoginRoute
  '/customer/logout': typeof PublicCustomerLogoutRoute
  '/customer/password': typeof PublicCustomerPasswordRoute
  '/companies/': typeof AppCompaniesIndexRoute
  '/employees/': typeof AppEmployeesIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/customer/': typeof PublicCustomerIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/login': typeof PublicLoginRoute
  '/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/customer/login': typeof PublicCustomerLoginRoute
  '/customer/logout': typeof PublicCustomerLogoutRoute
  '/customer/password': typeof PublicCustomerPasswordRoute
  '/companies': typeof AppCompaniesIndexRoute
  '/employees': typeof AppEmployeesIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/customer': typeof PublicCustomerIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/login': typeof PublicLoginRoute
  '/_app/': typeof AppIndexRoute
  '/_app/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/_app/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_public/customer/login': typeof PublicCustomerLoginRoute
  '/_public/customer/logout': typeof PublicCustomerLogoutRoute
  '/_public/customer/password': typeof PublicCustomerPasswordRoute
  '/_app/companies/': typeof AppCompaniesIndexRoute
  '/_app/employees/': typeof AppEmployeesIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_public/customer/': typeof PublicCustomerIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/companies/$companyId'
    | '/employees/$employeeId'
    | '/projects/$projectId'
    | '/customer/login'
    | '/customer/logout'
    | '/customer/password'
    | '/companies/'
    | '/employees/'
    | '/projects/'
    | '/customer/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/companies/$companyId'
    | '/employees/$employeeId'
    | '/projects/$projectId'
    | '/customer/login'
    | '/customer/logout'
    | '/customer/password'
    | '/companies'
    | '/employees'
    | '/projects'
    | '/customer'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_public/login'
    | '/_app/'
    | '/_app/companies/$companyId'
    | '/_app/employees/$employeeId'
    | '/_app/projects/$projectId'
    | '/_public/customer/login'
    | '/_public/customer/logout'
    | '/_public/customer/password'
    | '/_app/companies/'
    | '/_app/employees/'
    | '/_app/projects/'
    | '/_public/customer/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/companies/': {
      id: '/_app/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AppCompaniesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$companyId': {
      id: '/_app/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AppCompaniesCompanyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/': {
      id: '/_app/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AppEmployeesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/$employeeId': {
      id: '/_app/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof AppEmployeesEmployeeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/customer/': {
      id: '/_public/customer/'
      path: '/customer'
      fullPath: '/customer/'
      preLoaderRoute: typeof PublicCustomerIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/customer/login': {
      id: '/_public/customer/login'
      path: '/customer/login'
      fullPath: '/customer/login'
      preLoaderRoute: typeof PublicCustomerLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/customer/logout': {
      id: '/_public/customer/logout'
      path: '/customer/logout'
      fullPath: '/customer/logout'
      preLoaderRoute: typeof PublicCustomerLogoutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/customer/password': {
      id: '/_public/customer/password'
      path: '/customer/password'
      fullPath: '/customer/password'
      preLoaderRoute: typeof PublicCustomerPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppCompaniesCompanyIdRoute: typeof AppCompaniesCompanyIdRoute
  AppEmployeesEmployeeIdRoute: typeof AppEmployeesEmployeeIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppCompaniesIndexRoute: typeof AppCompaniesIndexRoute
  AppEmployeesIndexRoute: typeof AppEmployeesIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppCompaniesCompanyIdRoute: AppCompaniesCompanyIdRoute,
  AppEmployeesEmployeeIdRoute: AppEmployeesEmployeeIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppCompaniesIndexRoute: AppCompaniesIndexRoute,
  AppEmployeesIndexRoute: AppEmployeesIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicCustomerLoginRoute: typeof PublicCustomerLoginRoute
  PublicCustomerLogoutRoute: typeof PublicCustomerLogoutRoute
  PublicCustomerPasswordRoute: typeof PublicCustomerPasswordRoute
  PublicCustomerIndexRoute: typeof PublicCustomerIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicCustomerLoginRoute: PublicCustomerLoginRoute,
  PublicCustomerLogoutRoute: PublicCustomerLogoutRoute,
  PublicCustomerPasswordRoute: PublicCustomerPasswordRoute,
  PublicCustomerIndexRoute: PublicCustomerIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
